import { render, staticRenderFns } from "./CustomWellnessTemplateBuilderView.vue?vue&type=template&id=799a2103&scoped=true&lang=pug&"
import script from "./CustomWellnessTemplateBuilderView.vue?vue&type=script&lang=js&"
export * from "./CustomWellnessTemplateBuilderView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799a2103",
  null
  
)

export default component.exports